import React from 'react';
import { FormLabel, TextField } from '@mui/material';
import { useFormikContext } from 'formik';

const CompanyTextField = ({ name, label, required = false, disabled }) => {
	const { touched, errors, getFieldProps } = useFormikContext();
	const error = touched[name] && Boolean(errors[name]);

	return (
		<>
			<FormLabel required={required}>{label}</FormLabel>
			<TextField
				fullWidth
				disabled={disabled}
				error={error}
				helperText={error ? errors[name] : ''}
				{...getFieldProps(name)}
			/>
		</>
	);
};

export default CompanyTextField;
